var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.942 16.6669H11.767C11.4143 16.6319 11.0819 16.4853 10.8182 16.2486C10.5544 16.0118 10.373 15.6971 10.3003 15.3502L8.06699 5.00019L5.76699 10.3335C5.70194 10.4826 5.59468 10.6094 5.45845 10.6982C5.32222 10.787 5.16297 10.8341 5.00033 10.8335H2.50033C2.27931 10.8335 2.06735 10.7457 1.91107 10.5894C1.75479 10.4332 1.66699 10.2212 1.66699 10.0002C1.66699 9.77917 1.75479 9.56721 1.91107 9.41093C2.06735 9.25465 2.27931 9.16686 2.50033 9.16686H4.45033L6.54199 4.34186C6.6828 4.01807 6.92279 3.74737 7.22736 3.56878C7.53193 3.39019 7.88535 3.31294 8.23667 3.34816C8.58798 3.38338 8.91903 3.52926 9.18208 3.76477C9.44514 4.00027 9.62661 4.31323 9.70033 4.65852L11.9337 15.0002L14.2337 9.68352C14.2962 9.53134 14.4023 9.40107 14.5388 9.30912C14.6752 9.21718 14.8358 9.16768 15.0003 9.16686H17.5003C17.7213 9.16686 17.9333 9.25465 18.0896 9.41093C18.2459 9.56721 18.3337 9.77917 18.3337 10.0002C18.3337 10.2212 18.2459 10.4332 18.0896 10.5894C17.9333 10.7457 17.7213 10.8335 17.5003 10.8335H15.5503L13.4587 15.6585C13.3309 15.9556 13.1195 16.2091 12.8502 16.3882C12.5809 16.5672 12.2654 16.664 11.942 16.6669Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.f952d14665de2579c724c9122266f056.svg";
export { ForwardRef as ReactComponent };